module.exports = __webpack_public_path__ + "assets/images/xmas-bga7681ca4.jpg";